import { render, staticRenderFns } from "./common-entity-modal.vue?vue&type=template&id=960771be&scoped=true"
import script from "./common-entity-modal.ts?vue&type=script&lang=ts&external"
export * from "./common-entity-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./common-entity-modal.less?vue&type=style&index=0&id=960771be&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960771be",
  null
  
)

export default component.exports